/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios';
import hwaxios from '../api-service/HWAxios';
import { getCurrentFiltersValues, reportTypes, setFilterData } from '../reduxExports';
import rmsStore from '../rmsStore';
import { isEqual } from 'lodash';
import { fetchChargerStationReferenceData, fetchChargerVisibleIdReferenceData, fetchChargingHistoryStopReasonCodeReferenceData, fetchStopReasonCodeReferenceData } from '../referenceDataRedux/referenceDataCreators';

const url = process.env.REACT_APP_SERVER_BASE_URL

// TODO: CHARGING HISTORY LIST API
export const fetchChargingHistoryReportData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<ReportAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);
        const response = await hwaxios.post(url + '/report/charging-history', reqBody)       
        const action: Partial<ReportAction> = {
            type: reportTypes.FETCH_CHARGERS_HISTORY_DATA,
            chargingHistoryColumnHeaders: response.data?.columns,
            chargingHistoryData: response.data?.data?.history,
            chargingHistoryCount: response.data?.data?.count,
        }
        dispatch(action)
        if (response?.status === 200) {
            const loaderEndAction: Partial<ReportAction> = {
                type: reportTypes.SET_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

// TODO: EXPORT REPORTS
export const exportChargingHistoryReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/report/charging-history/export', reqParams)       
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}

// TODO: CHARGER LOGS LIST API
export const fetchChargerLogsData: any = (reqBody: any) => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<ReportAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);

        const filtersHash = reqBody?.filters
        const hashAction : Partial<ReportAction> = {
          type : reportTypes.SET_CHARGER_LOGS_LIST_REQUEST_HASH,
          chargerLogsFiltersRequestHash : filtersHash
        }
        dispatch(hashAction)
        const response = await hwaxios.post(url + '/report/charger/history', reqBody)
         
        if(isEqual(filtersHash ,rmsStore.getState().reportsReducer.chargerLogsFiltersRequestHash)){
            const action: Partial<ReportAction> = {
                type: reportTypes.FETCH_CHARGER_LOGS_DATA,
                chargerLogsColumnHeaders: response.data?.columns,
                chargerLogsData: response.data?.data?.history ?? response?.data?.data?.latest,
                chargerLogsCount: response.data?.data?.count,
            }
            dispatch(action)
        }

        if (response?.status === 200) {
            const loaderEndAction: Partial<ReportAction> = {
                type: reportTypes.SET_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

// TODO: EXPORT REPORTS
export const exportChargerLogsReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/report/charger/history/export', reqParams)       
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}

// TODO: EXCEPTION LOGS LIST API
export const fetchExceptionLogsData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<ReportAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);
        const response = await hwaxios.post(url + '/log-dashboard', reqBody)
        const action: Partial<ReportAction> = {
            type: reportTypes.FETCH_EXCEPTION_LOGS_DATA,
            exceptionLogsColumnHeaders: response.data?.columns,
            exceptionLogsData: response.data?.data?.logs,
            exceptionLogsCount: response.data?.data?.logCount,
        }
        dispatch(action)
        if (response?.status === 200) {
            const loaderEndAction: Partial<ReportAction> = {
                type: reportTypes.SET_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }
    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}

// TODO: EXPORT EXCEPTION LOGS
export const exportExceptionLogs: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/log-dashboard/export', reqParams)       
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}


// TODO: SET REPORT LIST TABLE PROPS
export const setReportListTableProps: any = (data,screen) => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    if (screen === 'chargingHistory') {
        const action: Partial<ReportAction> = {
            type: reportTypes.SET_CHARGING_HISTORY_LIST_TABLE_PROPS,
            chargingHistoryListTableProps: data,
        };
        dispatch(action);
      } else if (screen === 'chargerLogs') {
        const action = {
          type: reportTypes.SET_CHARGER_LOGS_LIST_TABLE_PROPS,
          chargerLogsListTableProps: data,
        }
        dispatch(action);
      }
      else if (screen === 'exceptionLogs') {
        const action = {
          type: reportTypes.SET_EXCEPTION_LOGS_LIST_TABLE_PROPS,
          exceptionLogsListTableProps: data,
        }
        dispatch(action);
      }
      else if (screen === 'sessionHistory'){
        const action: Partial<ReportAction> = {
            type: reportTypes.SET_SESSION_HISTORY_LIST_TABLE_PROPS,
            sessionHistoryListTableProps: data,
        }
        dispatch(action);
      }
      else if (screen === 'statusHistory'){
        const action: Partial<ReportAction> = {
            type: reportTypes.SET_STATUS_HISTORY_LIST_TABLE_PROPS,
            statusHistoryListTableProps: data,
        }
        dispatch(action);
      }
}

export const setRedirectedStateForChargingHistoryFilters: any = (data,stopReasonCode) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
        const stopReasonCodeRefData = (rmsStore.getState().referenceDataReducer.chargingHistoryStopReasonCodeReferenceData) ? (rmsStore.getState().referenceDataReducer.chargingHistoryStopReasonCodeReferenceData) : JSON.parse(await dispatch(fetchChargingHistoryStopReasonCodeReferenceData()));
        const chargerVisibleIdReferenceData = (rmsStore.getState().referenceDataReducer.chargerVisibleIdReferenceData) ? (rmsStore.getState().referenceDataReducer.chargerVisibleIdReferenceData) : JSON.parse(await dispatch(fetchChargerVisibleIdReferenceData()));
        const chargingStationReferenceData = (rmsStore.getState().referenceDataReducer.chargingStationReferenceData) ? (rmsStore.getState().referenceDataReducer.chargingStationReferenceData) : JSON.parse(await dispatch(fetchChargerStationReferenceData()));
        if(stopReasonCode){
            const stopReasonCodeFilter = stopReasonCodeRefData?.filter(item=>item?.name?.toLowerCase()?.includes(stopReasonCode?.toLowerCase()));
            await setFilterData(stopReasonCodeFilter,'stopReasonCode','chargingHistoryReport','SET',false)(dispatch);
            const failedTransactionScreenFilters = await getCurrentFiltersValues('failedTransaction',true);
            const chargerIds = failedTransactionScreenFilters?.filter(item=>item?.key==='chargerId')?.[0]?.values;
            const chargingStationIds = failedTransactionScreenFilters?.filter(item=>item?.key==='chargingStationId')?.[0]?.values;
            const chargerIdFilter = chargerVisibleIdReferenceData?.filter(item=>chargerIds?.includes(item?.id));
            const chargingStationIdFilter = chargingStationReferenceData?.filter(item=>chargingStationIds?.includes(item?.id));
            await setFilterData(chargerIdFilter,'chargerId','chargingHistoryReport','SET',false)(dispatch);
            await setFilterData(chargingStationIdFilter,'chargingStationId','chargingHistoryReport','SET',false)(dispatch);
        }
      const action = {
        type: reportTypes.SET_CHARGING_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION,
        chargingHistoryFiltersAppliedFromRedirection: data,
      };
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};


export const fetchSessionHistoryReportData: any = (reqBody: any) => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<ReportAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);

        const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== '' ? reqBody.searchTerm.trim() : null;
        const filtersHash = reqBody?.filters
        const hashAction : Partial<ReportAction> = {
          type : reportTypes.SET_SESSION_HISTORY_LIST_REQUEST_HASH,
          sessionHistoryFiltersRequestHash: filtersHash,
          sessionHistorySearchHash: searchHash
        }
        dispatch(hashAction)

        const response = await hwaxios.post(url + '/report/session-history', reqBody)

        if (  
            searchHash === rmsStore.getState().reportsReducer.sessionHistorySearchHash && 
            isEqual(filtersHash ,rmsStore.getState().reportsReducer.sessionHistoryFiltersRequestHash)
        ){       
            const action: Partial<ReportAction> = {
                type: reportTypes.FETCH_SESSION_HISTORY_DATA,
                sessionHistoryColumnHeaders: response.data?.columns,
                sessionHistoryData: response.data?.data?.history,
                sessionHistoryCount:  response.data?.data?.count?.[0]?.count,
            }
            dispatch(action)
        }

        if (response?.status === 200) {
            const loaderEndAction: Partial<ReportAction> = {
                type: reportTypes.SET_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }

    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}


export const exportSessionHistoryReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/report/session-history/export', reqParams)       
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}

export const setRedirectedStateForSessionHistoryFilters:any = (data) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const action = {
        type: reportTypes.SET_SESSION_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION,
        sessionHistoryFiltersAppliedFromRedirection: data,
      };
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};





export const fetchStatusHistoryReportData: any = (reqBody: any) => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    try {
        const loaderStartAction: Partial<ReportAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            reportLoader: true
        }
        dispatch(loaderStartAction);

        const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== '' ? reqBody.searchTerm.trim() : null;
        const filtersHash = reqBody?.filters
        const hashAction : Partial<ReportAction> = {
          type : reportTypes.SET_STATUS_HISTORY_LIST_REQUEST_HASH,
          statusHistoryFiltersRequestHash: filtersHash,
          statusHistorySearchHash: searchHash
        }
        dispatch(hashAction)

        const response = await hwaxios.post(url + '/report/charger/status-history', reqBody);

        if (  
            searchHash === rmsStore.getState().reportsReducer.statusHistorySearchHash && 
            isEqual(filtersHash ,rmsStore.getState().reportsReducer.statusHistoryFiltersRequestHash)
        ){       
            const action: Partial<ReportAction> = {
                type: reportTypes.FETCH_STATUS_HISTORY_DATA,
                statusHistoryColumnHeaders: response.data?.columns,
                statusHistoryData: response.data?.data?.history,
                statusHistoryCount:  response.data?.data?.count,
            }
            dispatch(action)
        }

        if (response?.status === 200) {
            const loaderEndAction: Partial<ReportAction> = {
                type: reportTypes.SET_REPORT_LOADER,
                reportLoader: false
            }
            dispatch(loaderEndAction);
        }

    } catch (error) {
        const loaderEndAction: Partial<UserAction> = {
            type: reportTypes.SET_REPORT_LOADER,
            loader: false
        }
        dispatch(loaderEndAction);
        console.error(error)
        throw error
    }
}


export const exportStatusHistoryReport: any = (reqParams: unknown) => async () => {
    try {
        const { data, status } = await hwaxios.post(url + '/report/charger/status-history/export', reqParams); 
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        } else {
            return {
                data: 'Something went wrong', status: 400
            }
        }
    }
}

export const setRedirectedStateForStatusHistoryFilters:any = (data) => async (dispatch) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const action = {
        type: reportTypes.SET_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION,
        statusHistoryFiltersAppliedFromRedirection: data,
      };
      await dispatch(action);
      // Resolve the promise
      resolve('Action dispatched successfully');
    } catch (error) {
      // Reject the promise with the error
      reject(error);
    }
  });
};

// TODO: STOP REASON ENUM PLC LOGS - FETCH ENABLED
export const fetchStopReasonEnumsEnabled: any = () => async (dispatch: (arg0: Partial<ReportAction>) => void): Promise<void> => {
    try {
        const response = await hwaxios.get(url + '/ref/stop-reason-enum-plc-logs-enabled');
        const action: Partial<ReportAction> = {
            type: reportTypes.FETCH_STOP_REASON_ENUMS_ENABLED,
            stopReasonEnumsEnabled: response.data?.data ?? [],
        }
        dispatch(action);
    } catch (error) {
        console.error(error);
        throw error;
    }
}

// STOP REASON ENUM PLC LOGS - FETCH ENABLED BY PRODUCT TYPE
export const fetchStopReasonEnumsEnabledByProductType: any = (productType: 1 | 2 | 3) => async () => {
    try {
        const response = await hwaxios.get(url + `/ref/stop-reason-enum-plc-logs-enabled?productType=${productType}`);
        return response.data?.data ?? [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

// STOP REASON ENUM PLC LOGS - FETCH ALL APPLICABLE BY PRODUCT TYPE
export const fetchStopReasonEnumsApplicableByProductType: any = (productType: 1 | 2 | 3) => async () => {
    try {
        const response = await hwaxios.get(url + `/ref/stop-reason-enum-plc-logs-applicable?productType=${productType}`);
        return response.data?.data ?? [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

// STOP REASON ENUM PLC LOGS - UPDATE BY PRODUCT TYPE
export const updateStopReasonPlcLogsApplicableByProductType: any = (reqBody: { productType: 1 | 2 | 3; enableIds: string[]; disableIds: string[] }) => async () => {
    try {
        const { data, status } = await hwaxios.put(url + '/ref/stop-reason-enum-plc-logs-applicable', reqBody);
        return { data, status };
    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                const data = error.response.data;
                const status = error.response.status;
                return { data, status };
            }
        }
        return { data: 'Something went wrong', status: 400 };
    }
}

export const fetchPlcLogConfiguration: any = () => async (dispatch) => {
    try {
        const response = await hwaxios.get(url + '/session-history/plc-configuration');
        const stopReasonReferenceData = (rmsStore.getState().referenceDataReducer.alertLogicStopReasonCodeRefData) ? rmsStore.getState().referenceDataReducer?.alertLogicStopReasonCodeRefData : JSON.parse(await dispatch(fetchStopReasonCodeReferenceData()));
        const productType1EnumsSet = new Set<string>(response?.data?.data?.productType1StopReasons ?? []);
        const productType2EnumsSet = new Set<string>(response?.data?.data?.productType2StopReasons ?? []);
        const productType3EnumsSet = new Set<string>(response?.data?.data?.productType3StopReasons ?? []);
        const data = {
            chargers: response?.data?.data?.chargers ?? [],
            productType1StopReasons: stopReasonReferenceData?.filter(item => productType1EnumsSet.has(item?.id)) ?? [],
            productType2StopReasons: stopReasonReferenceData?.filter(item => productType2EnumsSet.has(item?.id)) ?? [],
            productType3StopReasons: stopReasonReferenceData?.filter(item => productType3EnumsSet.has(item?.id)) ?? []
        }

        await new Promise(resolve=>setTimeout(resolve,1000));

        return data;
    } catch(error) {
        console.error(error);
        throw error;
    }
}

export const updatePlcLogConfiguration: any = async (reqBody: any) => {
  try {
    const { data, status } = await hwaxios.post(url + '/session-history/plc-configuration', reqBody);
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: {message: 'Something went wrong'}, status: 400
      };
    }
  }
}


export const fetchInventoryParamHistoryReport: any = (reqBody) =>  async (dispatch): Promise<void> => {
  try {
    const loaderStartAction: Partial<ReportAction>  = {
      type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
      inventoryParamHistoryLoader: true
    };

    dispatch(loaderStartAction)

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
      ? reqBody.searchTerm.trim() : null;

    const filterHash = reqBody?.filters;

     const hashAction: Partial<ReportAction> = {
        type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_REQUEST_HASH,
        inventoryParamHistoryRequestSearchHash: searchHash,
        inventoryParamHistoryRequestFilterHash: filterHash
    };
    
    dispatch(hashAction);

    const response = await hwaxios.post(url + '/report/inventory-params/history', reqBody);

    if (
        searchHash === rmsStore.getState().reportsReducer.inventoryParamHistoryRequestSearchHash &&
        isEqual(filterHash, rmsStore.getState().reportsReducer.inventoryParamHistoryRequestFilterHash)
    ) {
      const action = {
        type: reportTypes.FETCH_INVENTORY_PARAM_HISTORY_REPORT_DATA,
        inventoryParamHistoryData: response.data?.data?.list,
        inventoryParamHistoryColumns: response.data?.data?.columns
      };
      dispatch(action);
    }

    if (response?.status === 200) {
        const loaderEndAction: Partial<ReportAction>  = {
            type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
            inventoryParamHistoryLoader: false
        };
        dispatch(loaderEndAction);
    }

  } catch (error) {
    const loaderEndAction: Partial<ReportAction>  = {
      type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
      inventoryParamHistoryLoader: false
    };
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
}


export const setInventoryParamHistoryReportTableProps: any = (data) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  const action = {
    type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_TABLE_PROPS,
    inventoryParamHistoryTableProps: data,
  };
  dispatch(action);
};

export const exportInventoryParamHistoryReport: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/report/inventory-params/history/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

export const exportInventoryParamReport: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger/inventory-parameter/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}

export const fetchInventoryParamLatestLogsReport: any = (reqBody) =>  async (dispatch): Promise<void> => {
  try {
    const loaderStartAction: Partial<ReportAction>  = {
      type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
      inventoryParamHistoryLoader: true
    };

    dispatch(loaderStartAction)

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
      ? reqBody.searchTerm.trim() : null;

    const filterHash = reqBody?.filters;

     const hashAction: Partial<ReportAction> = {
        type: reportTypes.SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_REQUEST_HASH,
        inventoryParamLatestLogsDataRequestSearchHash: searchHash,
        inventoryParamLatestLogsDataRequestFilterHash: filterHash
    };
    
    dispatch(hashAction);

    const response = await hwaxios.post(url + '/report/inventory-params/latest', reqBody);

    if (
        searchHash === rmsStore.getState().reportsReducer.inventoryParamLatestLogsDataRequestSearchHash &&
        isEqual(filterHash, rmsStore.getState().reportsReducer.inventoryParamLatestLogsDataRequestFilterHash)
    ) {
      const action = {
        type: reportTypes.FETCH_INVENTORY_PARAM_LATEST_LOGS_REPORT_DATA,
        inventoryParamLatestLogsData: response.data?.data?.list,
        inventoryParamLatestLogsDataCount: response.data?.data?.count,
        inventoryParamLatestLogsColumns: response.data?.data?.columns
      };
      dispatch(action);
    }

    if (response?.status === 200) {
        const loaderEndAction: Partial<ReportAction>  = {
            type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
            inventoryParamHistoryLoader: false
        };
        dispatch(loaderEndAction);
    }

  } catch (error) {
    const loaderEndAction: Partial<ReportAction>  = {
      type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
      inventoryParamHistoryLoader: false
    };
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
}

export const setInventoryParamLatestLogsReportTableProps: any = (data) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  const action = {
    type: reportTypes.SET_INVENTORY_PARAM_LATEST_LOGS_REPORT_TABLE_PROPS,
    inventoryParamLatestLogsTableProps: data,
  };
  dispatch(action);
};

export const fetchInventoryParamChangeLogsReport: any = (reqBody) =>  async (dispatch): Promise<void> => {
  try {
    const loaderStartAction: Partial<ReportAction>  = {
      type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
      inventoryParamHistoryLoader: true
    };

    dispatch(loaderStartAction)

    const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
      ? reqBody.searchTerm.trim() : null;

    const filterHash = reqBody?.filters;

     const hashAction: Partial<ReportAction> = {
        type: reportTypes.SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_REQUEST_HASH,
        inventoryParamChangeLogsDataRequestSearchHash: searchHash,
        inventoryParamChangeLogsDataRequestFilterHash: filterHash
    };
    
    dispatch(hashAction);

    const response = await hwaxios.post(url + '/report/inventory-params/change-logs', reqBody);

    if (
        searchHash === rmsStore.getState().reportsReducer.inventoryParamChangeLogsDataRequestSearchHash &&
        isEqual(filterHash, rmsStore.getState().reportsReducer.inventoryParamChangeLogsDataRequestFilterHash)
    ) {
      const action = {
        type: reportTypes.FETCH_INVENTORY_PARAM_CHANGE_LOGS_REPORT_DATA,
        inventoryParamChangeLogsData: response.data?.data?.list,
        inventoryParamChangeLogsColumns: response.data?.data?.columns
      };
      dispatch(action);
    }

    if (response?.status === 200) {
        const loaderEndAction: Partial<ReportAction>  = {
            type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
            inventoryParamHistoryLoader: false
        };
        dispatch(loaderEndAction);
    }

  } catch (error) {
    const loaderEndAction: Partial<ReportAction>  = {
      type: reportTypes.SET_INVENTORY_PARAM_HISTORY_REPORT_LOADER,
      inventoryParamHistoryLoader: false
    };
    dispatch(loaderEndAction);
    console.error(error);
    throw error;
  }
}

export const setInventoryParamChangeLogsReportTableProps: any = (data) => async (dispatch: (arg0: Partial<ChargerAction>) => void): Promise<void> => {
  const action = {
    type: reportTypes.SET_INVENTORY_PARAM_CHANGE_LOGS_REPORT_TABLE_PROPS,
    inventoryParamChangeLogsTableProps: data,
  };
  dispatch(action);
};

export const exportInventoryParamChangeLogReport: any = (reqParams: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/report/inventory-params/change-logs/export', reqParams)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: 'Something went wrong', status: 400
      }
    }
  }
}